import React from 'react';
import { SEO } from '../components/SEO';
export const PrivacyPage = () => {
  return <main data-id="element-1637">
      <SEO title="Privacybeleid | BKCustoms" description="Lees ons privacybeleid. BKCustoms respecteert uw privacy en beschermt uw persoonlijke gegevens volgens de geldende wetgeving." data-id="element-1638" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-20" data-id="element-1639">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1640">
          <div className="absolute inset-0 bg-black/90 z-10" data-id="element-1641"></div>
          <img src="https://images.unsplash.com/photo-1557597774-9d273605dfa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Privacy Policy" className="w-full h-full object-cover object-center" data-id="element-1642" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1643">
          <h1 className="text-4xl font-bold text-white mb-6" data-id="element-1644">Privacybeleid</h1>
        </div>
      </div>
      {/* Content Section */}
      <section className="bg-[#0a0a0a] py-16" data-id="element-1645">
        <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-1646">
          <div className="bg-[#0f0f0f] border border-[#222] rounded-lg p-8 md:p-10" data-id="element-1647">
            <div className="prose prose-invert max-w-none" data-id="element-1648">
              <p className="text-white/80 mb-6" data-id="element-1649">
                <strong data-id="element-1650">Laatst bijgewerkt: 1 juni 2023</strong>
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1651">
                1. Inleiding
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1652">
                BKCustoms, gevestigd te Almere, is verantwoordelijk voor de
                verwerking van persoonsgegevens zoals weergegeven in deze
                privacyverklaring.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1653">
                2. Contactgegevens
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1654">
                Website: www.bkcustoms.nl
                <br data-id="element-1655" />
                Adres: Microfoonstraat 36, 1322 BN Almere
                <br data-id="element-1656" />
                Telefoon: +31 (0)6 278 88 306
                <br data-id="element-1657" />
                E-mail: info@bkcustoms.nl
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1658">
                3. Persoonsgegevens die wij verwerken
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1659">
                BKCustoms verwerkt uw persoonsgegevens doordat u gebruik maakt
                van onze diensten en/of omdat u deze zelf aan ons verstrekt.
                Hieronder vindt u een overzicht van de persoonsgegevens die wij
                verwerken:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1660">
                <li data-id="element-1661">Voor- en achternaam</li>
                <li data-id="element-1662">Adresgegevens</li>
                <li data-id="element-1663">Telefoonnummer</li>
                <li data-id="element-1664">E-mailadres</li>
                <li data-id="element-1665">Gegevens over uw voertuig</li>
                <li data-id="element-1666">Overige persoonsgegevens die u actief verstrekt</li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1667">
                4. Doeleinden gegevensverwerking
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1668">
                BKCustoms verwerkt uw persoonsgegevens voor de volgende doelen:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1669">
                <li data-id="element-1670">Het afhandelen van uw betaling</li>
                <li data-id="element-1671">U te kunnen bellen of e-mailen indien nodig</li>
                <li data-id="element-1672">U te informeren over onze diensten en wijzigingen</li>
                <li data-id="element-1673">Het uitvoeren van de overeenkomst</li>
                <li data-id="element-1674">
                  Voor het verzenden van onze nieuwsbrief (alleen met expliciete
                  toestemming)
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1675">
                5. Bewaartermijn
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1676">
                BKCustoms bewaart uw persoonsgegevens niet langer dan strikt
                nodig is om de doelen te realiseren waarvoor uw gegevens worden
                verzameld. Wij hanteren de volgende bewaartermijnen:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1677">
                <li data-id="element-1678">
                  Klantgegevens: 7 jaar (wettelijke bewaartermijn
                  belastingdienst)
                </li>
                <li data-id="element-1679">Gegevens voor marketingdoeleinden: 2 jaar</li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1680">
                6. Delen van persoonsgegevens met derden
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1681">
                BKCustoms verkoopt uw gegevens niet aan derden en verstrekt deze
                uitsluitend indien dit nodig is voor de uitvoering van onze
                overeenkomst met u of om te voldoen aan een wettelijke
                verplichting.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1682">
                7. Cookies en vergelijkbare technieken
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1683">
                BKCustoms gebruikt alleen technische, functionele en analytische
                cookies die geen inbreuk maken op uw privacy. Een cookie is een
                klein tekstbestand dat bij het eerste bezoek aan deze website
                wordt opgeslagen op uw computer, tablet of smartphone.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1684">
                8. Uw rechten
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1685">
                U heeft het recht om uw persoonsgegevens in te zien, te
                corrigeren of te verwijderen. Daarnaast heeft u het recht om uw
                eventuele toestemming voor de gegevensverwerking in te trekken
                of bezwaar te maken tegen de verwerking van uw persoonsgegevens
                door BKCustoms.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1686">
                9. Wijzigingen in deze privacyverklaring
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1687">
                BKCustoms kan deze privacyverklaring aanpassen. De meest actuele
                versie vindt u altijd op onze website.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1688">
                10. Contact
              </h2>
              <p className="text-white/80" data-id="element-1689">
                Als u vragen heeft over deze privacyverklaring, neem dan contact
                met ons op via info@bkcustoms.nl.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
};